import React from 'react';
import {Body} from '@lightricks/react-design-system';
import {getPriceCurrency} from '@contentlab/views/contentlab/pricing/utils';
import translate from '@/utils/translate';
import Duration from '@/types/models/pricing/duration';
import {SubscriptionPlan} from '@/types/models/pricing/subscriptionPlan';

type PriceFootnoteProps = {
  selectedDuration: Duration;
  selectedSubscriptionPlan: SubscriptionPlan;
  isTrialFeatureEnabled?: boolean;
  className?: string;
};

function PriceFootnote({
  selectedDuration,
  selectedSubscriptionPlan,
  className,
  isTrialFeatureEnabled = false,
}: PriceFootnoteProps) {
  const getPriceText = (price: number | undefined) => {
    return price
      ? getPriceCurrency(selectedSubscriptionPlan.currency, price)
      : '';
  };

  const getMonthlyEquivalent = (yearlyPrice: number) => {
    const monthlyEquivalent = Math.round(yearlyPrice / 12);
    return getPriceText(monthlyEquivalent);
  };

  const getDurationFootnote = () => {
    if (isTrialFeatureEnabled) {
      if (selectedDuration === Duration.YEARLY) {
        const {yearlyPrice} = selectedSubscriptionPlan;
        if (!yearlyPrice) {
          return '';
        }
        const yearlyPriceText = getPriceText(yearlyPrice);
        const monthlyEquivalentText = getMonthlyEquivalent(yearlyPrice);

        return `${translate('annual-billing', {
          annualPrice: yearlyPriceText,
          monthlyPrice: monthlyEquivalentText,
        })}`;
      }
      return `Then ${getPriceText(selectedSubscriptionPlan.price)} ${translate(
        'billed monthly'
      )}`;
    }

    if (selectedDuration === Duration.YEARLY) {
      return `${getPriceText(
        selectedSubscriptionPlan.yearlyPrice ?? undefined
      )} ${translate('Billed annually')}`;
    }
    return translate('Billed monthly');
  };

  const DurationFootnote = getDurationFootnote();
  return (
    <Body size="md" className={className}>
      {DurationFootnote}
    </Body>
  );
}

export default PriceFootnote;
